import React from 'react';

export default function IndustrialButton({
  children,
  onClick,
  variant = 'primary',
  className = '',
  type = 'button',
  disabled = false,
  testId,
  ariaLabel,
}) {
  const variantClass = variant === 'dark'
    ? 'industrial-btn-dark'
    : variant === 'light'
      ? 'industrial-btn-light'
      : 'industrial-btn-primary';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`industrial-btn ${variantClass} ${className}`}
      data-testid={testId}
    >
      {children}
    </button>
  );
}
